import React from "react";

import classNames from "classnames";
import { Props } from "./types";
import { Record } from "./record";
import { ResourceTimeOverview } from "./resourceTimeOverview";
import styles from "./styles.scss";

function RecordList({ type }: Props) {
  return (
    <div
      className={classNames(styles.recordList, {
        [styles.resource]: type === "resource",
        [styles.list]: type === "list" || type === "project",
        [styles.task]: type === "task",
      })}
    >
      <div className={styles.dates}>
        {[1, 2, 3, 4, 5, 6, 7].map((date) => (
          <div key={date} className={styles.record}>
            <Record />
          </div>
        ))}
      </div>
      <div className={styles.timeOverview}>
        <ResourceTimeOverview type={type} />
      </div>
    </div>
  );
}

export { RecordList };
